import React from 'react';

import { useSelector } from 'react-redux';

import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../../../shared/features/flags/selectors';
import { SummarizationStopModal as SummarizationStopModalNew } from './summarization-stop-modal-new';
import { SummarizationStopModal as SummarizationStopModalOld } from './summarization-stop-modal-old';

export const SummarizationStopModal = (props: object) => {
    const isCalendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);
    return isCalendarSummarizationFeatureEnabled ? (
        <SummarizationStopModalNew {...props} />
    ) : (
        <SummarizationStopModalOld {...props} />
    );
};
